import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const EDCRFAQ = () => {
  return (
    <Container style={{ alignItems: 'flex-start', textAlign: 'left', marginTop: '20px', marginLeft: '-30px' }}>     
      <Box mb={4}>
        <Typography variant="h6" align="justify" gutterBottom>
          FAQ Regarding (User manual and Sample Drawing in EDCR Format)
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>1. Where you can Find Sample drawing and User manual form EDCR Format?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              First Use URL hptcp.hp.gov.in and Click on TCP department on Right corner you will redirect to the TCP Department Homepage in the Header of the TCP Homepage you will file a tab of User manual click on that and you can access EDCR related Document and Sample drawings.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
      
      <Box mb={4}>
        <Typography variant="h6" align="justify">
          FAQ Regarding (EDCR Layers)
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>2. Where You can find DXF Drawing EDCR Format layers details?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              In the User manual downloaded from the TCP New portal please refer to page no 188 and read all the Instructions and Layers details.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" align="justify">
          FAQ Regarding (Professional Login)
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>3. How Professional Can Login in New Portal?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              From the TCP New Portal Click on Online services and on next page click Sign in you have to enter the mobile no. Already registered with the old Portal no need of Userid and Password you can access from the OTP received on the Registered mobile no.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" align="justify">
          FAQ Regarding (Self Certification Process)
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>4. Which type of application professional can Self Certify?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              In the new Portal (hptcp.hp.gov.in) Professional can self certify those application which are Proposed Residential plan in which CLU is not involved and below 500 sqmtr only these files Professional can self certify.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>5. Where you can find the Manual of Self Certification Process?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              In User manual Page no 42 (3.2.1) You will get the Self certification Process detailed workflow.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" align="justify">
          FAQ Regarding (Mandatory Steps for Users regarding Signature uploading)
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>6. What type of Steps to be taken by Users for generating Approval letter with Signature?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              When any professional or User log into id then first step you have to upload signature and photo from the edit profile section. Then only Signature will upload on the approval letter.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>7. How Professionals and Officers can upload Signature and Photo in Profile?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              In the new Portal (hptcp.hp.gov.in) Professional can self certify those application which are Proposed Residential plan in which CLU is not involved and below 500 sqmtr only these files Professional can self certify.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
};

export default EDCRFAQ;
